import { apiSlice } from "./apiSlice";
import { ORDERS_URL } from "../constants";

const ordersApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    createOrder: builder.mutation({
      query: (data) => ({
        url: `${ORDERS_URL}/createOrder`,
        method: "POST",
        body: data,
        headers: {
          Authorization: `Bearer ${data.token}`,
        },
      }),
    }),
    getMyOrders: builder.mutation({
      query: (data) => ({
        url: `${ORDERS_URL}/getMyOrders`,
        method: "POST",
        body: data,
        headers: {
          Authorization: `Bearer ${data?.token}`,
        },
      }),
    }),
    getOrderById: builder.query({
      query: (data) => ({
        url: `${ORDERS_URL}/getOrders/${data.orderId}`,
        method: "GET",
        headers: {
          Authorization: `Bearer ${data?.token}`,
        },
      }),
    }),
    createTableOrder: builder.mutation({
      query: (data) => ({
        url: `${ORDERS_URL}/createTableOrder`,
        method: "POST",
        body: data,
        headers: {
          Authorization: `Bearer ${data.token}`,
        },
      }),
    }),
  }),
});

export const {
  useCreateOrderMutation,
  useGetMyOrdersMutation,
  useGetOrderByIdQuery,
  useCreateTableOrderMutation,
} = ordersApiSlice;
